export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Concept & Planning',
      description: 'We start by understanding your goals, target audience, and vision. Together we develop a creative concept, script, and production plan that aligns with your objectives.'
    },
    {
      number: '02',
      title: 'Filming',
      description: 'Our experienced crew captures your story with professional cinema cameras, lighting, and audio equipment. We handle all aspects of production to ensure smooth execution.'
    },
    {
      number: '03',
      title: 'Editing & Post-Production',
      description: 'We transform raw footage into a polished final product with professional editing, color grading, motion graphics, and sound design that elevates your message.'
    },
    {
      number: '04',
      title: 'Delivery',
      description: 'Receive your finished video in multiple formats optimized for your intended platforms. We provide ongoing support and revisions to ensure your complete satisfaction.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Production Process
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            A streamlined approach from concept to final delivery
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="text-6xl font-bold text-[#1E3A8A]/10 mb-4">
                {step.number}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}